import { render, staticRenderFns } from "./ApiErrorDisplay.vue?vue&type=template&id=818fc00a&"
import script from "./ApiErrorDisplay.vue?vue&type=script&lang=js&"
export * from "./ApiErrorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports